import { render, staticRenderFns } from "./CoinAnatomy.vue?vue&type=template&id=e0a387f2&"
import script from "./CoinAnatomy.vue?vue&type=script&lang=ts&"
export * from "./CoinAnatomy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports